/**
 * Created by anthony on 11/20/14.
 */
var awardCalculation = angular.module('awardCalculation', ['classy', 'calculationService', 'alertService', 'resetService',
    'housingService', 'pulsateService', 'resetService', 'sliderCud']);